module.exports = __webpack_public_path__ + "assets-cabinet/img/close-icon2.b84ff35a.svg";